// React Component
import React from 'react'

// App Component
import Home from './Home'


const DashboardView = () => {
    return (
        <Home />
    )
}

export default DashboardView